// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { OnlineResource } from "./OnlineResource";
import {
  OnlineResourceFromJSON,
  OnlineResourceFromJSONTyped,
  OnlineResourceToJSON,
  OnlineResourceToJSONTyped,
} from "./OnlineResource";
import type { ISO19115Keywords } from "./ISO19115Keywords";
import {
  ISO19115KeywordsFromJSON,
  ISO19115KeywordsFromJSONTyped,
  ISO19115KeywordsToJSON,
  ISO19115KeywordsToJSONTyped,
} from "./ISO19115Keywords";
import type { QualityReport } from "./QualityReport";
import {
  QualityReportFromJSON,
  QualityReportFromJSONTyped,
  QualityReportToJSON,
  QualityReportToJSONTyped,
} from "./QualityReport";
import type { Citation } from "./Citation";
import {
  CitationFromJSON,
  CitationFromJSONTyped,
  CitationToJSON,
  CitationToJSONTyped,
} from "./Citation";
import type { LegalRestriction } from "./LegalRestriction";
import {
  LegalRestrictionFromJSON,
  LegalRestrictionFromJSONTyped,
  LegalRestrictionToJSON,
  LegalRestrictionToJSONTyped,
} from "./LegalRestriction";
import type { ResponsibleParty } from "./ResponsibleParty";
import {
  ResponsiblePartyFromJSON,
  ResponsiblePartyFromJSONTyped,
  ResponsiblePartyToJSON,
  ResponsiblePartyToJSONTyped,
} from "./ResponsibleParty";
import type { ISO6392B } from "./ISO6392B";
import {
  ISO6392BFromJSON,
  ISO6392BFromJSONTyped,
  ISO6392BToJSON,
  ISO6392BToJSONTyped,
} from "./ISO6392B";
import type { StatusCode } from "./StatusCode";
import {
  StatusCodeFromJSON,
  StatusCodeFromJSONTyped,
  StatusCodeToJSON,
  StatusCodeToJSONTyped,
} from "./StatusCode";
import type { SpatialSchemaCode } from "./SpatialSchemaCode";
import {
  SpatialSchemaCodeFromJSON,
  SpatialSchemaCodeFromJSONTyped,
  SpatialSchemaCodeToJSON,
  SpatialSchemaCodeToJSONTyped,
} from "./SpatialSchemaCode";
import type { DistributionFormat } from "./DistributionFormat";
import {
  DistributionFormatFromJSON,
  DistributionFormatFromJSONTyped,
  DistributionFormatToJSON,
  DistributionFormatToJSONTyped,
} from "./DistributionFormat";

/**
 *
 * @export
 * @interface ISO19115Dataset
 */
export interface ISO19115Dataset {
  /**
   * Unieke ID voor de metadata file.
   */
  identifier?: string;
  /**
   * Taal gebruikt om de metadata te beschrijven.
   */
  language?: ISO6392B;
  /**
   *
   */
  hierarchyLevel?: ISO19115DatasetHierarchyLevelEnum;
  /**
   * Conditioneel indien een dataset (serie) met hogere hierarchie bestaat.
   */
  parentIdentifier?: string | null;
  /**
   *
   */
  metadataContact?: ResponsibleParty | null;
  /**
   *
   */
  dateStamp?: Date;
  /**
   * The Coordinate Reference System as an EPSG code, for example: 'EPSG:123456'. Raster transformations are done using PROJ4 version 9.6.0.
   */
  spatialReferenceSystem?: string | null;
  /**
   *
   */
  dataCitation?: Citation;
  /**
   * Korte beschrijving van de inhoud van de dataset.
   */
  _abstract?: string | null;
  /**
   * Het doel van de dataset.
   */
  purpose?: string | null;
  /**
   * Status van de dataset.
   */
  status?: StatusCode;
  /**
   *
   */
  dataContact?: ResponsibleParty | null;
  /**
   * URL naar een afbeelding die de dataset samenvat.
   */
  graphicOverview?: string | null;
  /**
   *
   */
  keywords?: Array<ISO19115Keywords>;
  /**
   * Toepassingen waarvoor de data niet geschikt is.
   */
  useLimitations?: Array<string>;
  /**
   * Juridische beperkingen voor het gebruik van de data.
   */
  legalRestrictions?: Array<LegalRestriction>;
  /**
   * Methode die gebruikt wordt om de geografische informatie ruimtelijk te representeren.
   */
  spatialSchema?: SpatialSchemaCode;
  /**
   * De beoogde schaal waarop het bestand waarheidsgetrouw gebruikt mag worden. Dit moet een positief numeriek getal zijn.
   */
  equivalentScale?: number | null;
  /**
   * De resolutie van de dataset in meters.
   */
  resolution?: number | null;
  /**
   * Taal waarmee de dataset beschreven is.
   */
  dataLanguage?: ISO6392B;
  /**
   * Hoofdthema's van de dataset.
   */
  topicCategory?: Array<string>;
  /**
   * De coördinaten dienen te worden weergegeven volgens referentiesysteem WGS 84.
   */
  spatialExtent?: Array<Array<number>>;
  /**
   *
   */
  distributionFormats?: Array<DistributionFormat>;
  /**
   *
   */
  transferOptions?: Array<OnlineResource>;
  /**
   *
   */
  dataQualityReports?: Array<QualityReport>;
  /**
   * Algemene beschrijving of opmerking, betreffend de geschiedenis van de bron. Dit kunnen ook beschrijvingen of opmerkingen zijn over de brongegevens en/of het productieproces.
   */
  dataLineage?: string | null;
}

/**
 * @export
 */
export const ISO19115DatasetHierarchyLevelEnum = {
  Dataset: "dataset",
} as const;
export type ISO19115DatasetHierarchyLevelEnum =
  (typeof ISO19115DatasetHierarchyLevelEnum)[keyof typeof ISO19115DatasetHierarchyLevelEnum];

/**
 * Check if a given object implements the ISO19115Dataset interface.
 */
export function instanceOfISO19115Dataset(value: object): value is ISO19115Dataset {
  return true;
}

export function ISO19115DatasetFromJSON(json: any): ISO19115Dataset {
  return ISO19115DatasetFromJSONTyped(json, false);
}

export function ISO19115DatasetFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ISO19115Dataset {
  if (json == null) {
    return json;
  }
  return {
    identifier: json["identifier"] == null ? undefined : json["identifier"],
    language: json["language"] == null ? undefined : ISO6392BFromJSON(json["language"]),
    hierarchyLevel: json["hierarchy_level"] == null ? undefined : json["hierarchy_level"],
    parentIdentifier:
      json["parent_identifier"] === undefined
        ? undefined
        : json["parent_identifier"] === null
        ? null
        : json["parent_identifier"],
    metadataContact:
      json["metadata_contact"] === undefined
        ? undefined
        : json["metadata_contact"] === null
        ? null
        : ResponsiblePartyFromJSON(json["metadata_contact"]),
    dateStamp: json["date_stamp"] == null ? undefined : parseDate(json["date_stamp"]),
    spatialReferenceSystem:
      json["spatial_reference_system"] === undefined
        ? undefined
        : json["spatial_reference_system"] === null
        ? null
        : json["spatial_reference_system"],
    dataCitation:
      json["data_citation"] == null ? undefined : CitationFromJSON(json["data_citation"]),
    _abstract:
      json["abstract"] === undefined
        ? undefined
        : json["abstract"] === null
        ? null
        : json["abstract"],
    purpose:
      json["purpose"] === undefined ? undefined : json["purpose"] === null ? null : json["purpose"],
    status: json["status"] == null ? undefined : StatusCodeFromJSON(json["status"]),
    dataContact:
      json["data_contact"] === undefined
        ? undefined
        : json["data_contact"] === null
        ? null
        : ResponsiblePartyFromJSON(json["data_contact"]),
    graphicOverview:
      json["graphic_overview"] === undefined
        ? undefined
        : json["graphic_overview"] === null
        ? null
        : json["graphic_overview"],
    keywords:
      json["keywords"] == null
        ? undefined
        : (json["keywords"] as Array<any>).map(ISO19115KeywordsFromJSON),
    useLimitations: json["use_limitations"] == null ? undefined : json["use_limitations"],
    legalRestrictions:
      json["legal_restrictions"] == null
        ? undefined
        : (json["legal_restrictions"] as Array<any>).map(LegalRestrictionFromJSON),
    spatialSchema:
      json["spatial_schema"] == null
        ? undefined
        : SpatialSchemaCodeFromJSON(json["spatial_schema"]),
    equivalentScale:
      json["equivalent_scale"] === undefined
        ? undefined
        : json["equivalent_scale"] === null
        ? null
        : json["equivalent_scale"],
    resolution:
      json["resolution"] === undefined
        ? undefined
        : json["resolution"] === null
        ? null
        : json["resolution"],
    dataLanguage:
      json["data_language"] == null ? undefined : ISO6392BFromJSON(json["data_language"]),
    topicCategory: json["topic_category"] == null ? undefined : json["topic_category"],
    spatialExtent: json["spatial_extent"] == null ? undefined : json["spatial_extent"],
    distributionFormats:
      json["distribution_formats"] == null
        ? undefined
        : (json["distribution_formats"] as Array<any>).map(DistributionFormatFromJSON),
    transferOptions:
      json["transfer_options"] == null
        ? undefined
        : (json["transfer_options"] as Array<any>).map(OnlineResourceFromJSON),
    dataQualityReports:
      json["data_quality_reports"] == null
        ? undefined
        : (json["data_quality_reports"] as Array<any>).map(QualityReportFromJSON),
    dataLineage:
      json["data_lineage"] === undefined
        ? undefined
        : json["data_lineage"] === null
        ? null
        : json["data_lineage"],
  };
}

export function ISO19115DatasetToJSON(json: any): ISO19115Dataset {
  return ISO19115DatasetToJSONTyped(json, false);
}

export function ISO19115DatasetToJSONTyped(
  value?: ISO19115Dataset | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    identifier: value["identifier"],
    language: ISO6392BToJSON(value["language"]),
    hierarchy_level: value["hierarchyLevel"],
    parent_identifier: value["parentIdentifier"],
    metadata_contact: ResponsiblePartyToJSON(value["metadataContact"]),
    date_stamp: value["dateStamp"] == null ? value["dateStamp"] : serializeDate(value["dateStamp"]),
    spatial_reference_system: value["spatialReferenceSystem"],
    data_citation: CitationToJSON(value["dataCitation"]),
    abstract: value["_abstract"],
    purpose: value["purpose"],
    status: StatusCodeToJSON(value["status"]),
    data_contact: ResponsiblePartyToJSON(value["dataContact"]),
    graphic_overview: value["graphicOverview"],
    keywords:
      value["keywords"] == null
        ? undefined
        : (value["keywords"] as Array<any>).map(ISO19115KeywordsToJSON),
    use_limitations: value["useLimitations"],
    legal_restrictions:
      value["legalRestrictions"] == null
        ? undefined
        : (value["legalRestrictions"] as Array<any>).map(LegalRestrictionToJSON),
    spatial_schema: SpatialSchemaCodeToJSON(value["spatialSchema"]),
    equivalent_scale: value["equivalentScale"],
    resolution: value["resolution"],
    data_language: ISO6392BToJSON(value["dataLanguage"]),
    topic_category: value["topicCategory"],
    spatial_extent: value["spatialExtent"],
    distribution_formats:
      value["distributionFormats"] == null
        ? undefined
        : (value["distributionFormats"] as Array<any>).map(DistributionFormatToJSON),
    transfer_options:
      value["transferOptions"] == null
        ? undefined
        : (value["transferOptions"] as Array<any>).map(OnlineResourceToJSON),
    data_quality_reports:
      value["dataQualityReports"] == null
        ? undefined
        : (value["dataQualityReports"] as Array<any>).map(QualityReportToJSON),
    data_lineage: value["dataLineage"],
  };
}
